import { GetBy } from '../_app/cuchillo/core/Element';
import Keyboard, { KEYS } from '../_app/cuchillo/core/Keyboard';
import _Header from '../_app/cuchillo/layout/Header';
import gsap, { Power2, Power3, Power4 } from "gsap";

export default class Header extends _Header {
  static isFixed = true;
  static options = {
    show: {
      duration: .3,
      delay: 0,
      ease: Power3.easeOut
    },
    hide: {
      duration: .3,
      delay: 0,
      ease: Power3.easeIn
    }
  }

  static hideAlpha() {
    this.container.pointerEvents = "none";
    gsap.to(this.container,
      {
        alpha: 0,
        duration: .3,
        delay: 0,
        ease: Power2.easeOut
      });
  }

  static showAlpha() {
    this.container.pointerEvents = "all";
    gsap.to(this.container,
      {
        alpha: 1,
        duration: .3,
        delay: 0,
        ease: Power2.easeOut
      });
  }

  static logo;
  static holder;
  static title;
  static claim;
  static yHide;
  static nav;
  static isShow = true;

  static overlay = GetBy.id("Header__blur");
  static _blur = 0;
  static get blur() { return this._blur; }
  static set blur(__n) {
    this._blur = __n;
    this.overlay.style.setProperty('--blur', `${this._blur}px`);
  }

  static _size = 0;
  static get size() { return this._scale; }
  static set size(__n) {
    this._size = __n;
    this.overlay.style.setProperty('--size', `${this._size}`);
  }

  static _overlayAlpha = 0;
  static get overlayAlpha() { return this._overlayAlpha; }
  static set overlayAlpha(__n) {
    this._overlayAlpha = __n;
    this.overlay.style.setProperty('--opacity', `${this._overlayAlpha}`);
  }

  static init () {
    this.logo = GetBy.class("__logo", this.container)[0];
    this.title = GetBy.class("__title", this.container)[0];
    this.claim = GetBy.class("__claim", this.container)[0];
    this.nav = GetBy.class("__nav", this.container)[0];
    this.holder = GetBy.class("holder", this.container)[0];
    this.overlayTop = GetBy.class("top", this.overlay)[0];
    this.overlayBottom = GetBy.class("bottom", this.overlay)[0];
  }

  static closeHeader() {
    if(!this.isShow) return;
    this.isShow = false;

    gsap.killTweensOf(this.title);
    gsap.killTweensOf(this.claim);
    gsap.killTweensOf(this.holder);

    gsap.to(this.title, {alpha:0, duration:.4, delay:0, ease: Power2.easeIn});
    gsap.to(this.claim, {alpha:0, duration:.4, delay:.0, ease: Power2.easeIn});
    
    gsap.to(this.title, {y: this.yHide*.25, duration:.8, ease: Power4.easeInOut});
    gsap.to(this.claim, {y: this.yHide*.5, duration:.8, ease: Power4.easeInOut});
    gsap.to(this.nav, {y: this.yHide, duration:.8, ease: Power4.easeInOut});
  }

  static openHeader() {
    if(this.isShow) return;
    this.isShow = true;

    gsap.killTweensOf(this.title);
    gsap.killTweensOf(this.claim);
    gsap.killTweensOf(this.holder);
    gsap.to(this.title, {alpha:1, duration:.4, delay:.1, ease: Power2.easeIn});
    gsap.to(this.claim, {alpha:1,duration:.4, delay:.2, ease: Power2.easeIn});

    gsap.to(this.title, {y: 0, duration:.8, ease: Power4.easeInOut});
    gsap.to(this.nav, {y: 0, duration:.8, ease: Power4.easeInOut});
    gsap.to(this.claim, {y: 0, duration:.8, ease: Power4.easeInOut});
  }

  static showOverlay(__top = true, __bottom = true) {
    if(__top) this.overlayTop.style.visibility = 'visible';
    if(__bottom) this.overlayBottom.style.visibility = 'visible';
  }

  static hideOverlay(__top = true, __bottom = true) {
    if(__top) this.overlayTop.style.visibility = 'hidden';
    if(__bottom) this.overlayBottom.style.visibility = 'hidden';
  }

  static hideLogo() {
    gsap.killTweensOf(this.logo);
    gsap.to(this.logo, {alpha:0, duration:.4, ease: Power2.easeOut});
  }

  static showLogo() {
    gsap.killTweensOf(this.logo);
    gsap.to(this.logo, {alpha:1, duration:.4, ease: Power2.easeIn});
  }

  static resize() {
    super.resize();
    this.yHide = this.title.getBoundingClientRect().top - this.nav.getBoundingClientRect().top;
  }
}


